// extracted by mini-css-extract-plugin
export default {"bodyFooter":"Footer_bodyFooter__CdTjX","icons":"Footer_icons__66jCE","copyright":"Footer_copyright__tRi3g"};